<template>
  <kbd
    v-bind="$attrs"
    class="rounded border border-line-strong bg-surface-muted px-1.5 py-0.5 text-xs font-semibold text-content-secondary hover:text-primary-hover"
  >
    <slot />
  </kbd>
</template>
